$(document).ready(() => {
    let userStatsOrder = $('.tournamentStats .versus-stats-points').hasClass('d-none')
        ? [[6, 'desc'], [0, 'asc']]
        : [[4, 'desc'], [0, 'asc']];

    const currentUrl = TRNMNT_helpers.parseUrl();
    const $menuFilter = $('#tournamentTab li');

    if (currentUrl.params) {
        if (currentUrl.params.tm) {
            $menuFilter.find(`button[data-id=${currentUrl.params.tm}]`).click();
        }
        if (currentUrl.params.ttsoc && currentUrl.params.ttsod) {
            userStatsOrder = $('.tournamentStats .versus-stats-points').hasClass('d-none') && currentUrl.params.ttsoc == 6
                ? [[currentUrl.params.ttsoc, currentUrl.params.ttsod], [0, 'asc']]
                : [[currentUrl.params.ttsoc, currentUrl.params.ttsod], [0, 'asc']];
        }
    }

    const $table = $('.tournamentStats')
        .DataTable({
            language: {
                url: '/dataTables.ru.json'
            },
            scrollX: true,
            lengthChange: false,
            layout: {
                bottomEnd: {
                    paging: {
                        firstLast: false,
                    },
                },
            },
            paging: false,
            info: false,
            order: userStatsOrder,
            search: {
                return: true,
            },
            searching: false,
            initComplete: (settings, json) => {
                $('div.dataTables_filter input').addClass('form-control-dark');
            },
            columns: [
                //№
                {className: "align-middle rounded-start text-end stats-data-platform", orderable: false},
                //Аватар
                {className: "align-middle stats-data-avatar", orderable: false},
                //Платформа
                {className: "align-middle stats-data-platform", orderable: false},
                //Название
                {className: "align-middle text-nowrap title-row", orderable: false},
                //Очки
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Игры
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Победы
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Поражения
                {className: "align-middle fw-bold stats-data"},
                //Поражения в ОТ
                {className: "align-middle fw-bold stats-data"},
                //Поражения по буллитам
                {className: "align-middle fw-bold stats-data"},
                //Процент побед
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Забито голов
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //+/-
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Броски
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Силовые приёмы
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Процент паса
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Вбрасывания
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Большинство
                {className: "align-middle fw-bold stats-data", orderSequence: ['desc', 'asc']},
                //Голы в меньшинстве
                {className: "align-middle rounded-end fw-bold stats-data", orderSequence: ['desc', 'asc']},
            ]
        });

    $menuFilter.on('click', event => {
        event.preventDefault();

        TRNMNT_helpers.deleteAllQueryParams();
        TRNMNT_helpers.insertURLQueryParam('tm', $(event.target).data('id'));
    });

    $table.on('order.dt', function () {
        // This will show: "Ordering on column 1 (asc)", for example
        const order = $table.order();
        TRNMNT_helpers.insertURLQueryParam('ttsoc', order[0][0]);
        TRNMNT_helpers.insertURLQueryParam('ttsod', order[0][1]);
    });

    $('.play-card button').on('click', createPairs);
    $('.play-card-double button').on('click', createPairs);

    function createPairs(event) {
        console.log('clkick');

        event.preventDefault();

        let $card = $(event.target).closest('.play-card');
        if ($card.length === 0) {
            $card = $(event.target).closest('.play-card-double');
        }

        const round = $card.data('round');
        const pair = $card.data('pair');
        const user_one_id = +$card.find('.team-one').val();
        const user_two_id = +$card.find('.team-two').val();
        const pair_id = $card.data('pairid');
        const bracket = $card.data('bracket');

        let data = {};
        if (pair_id) {
            if (user_one_id) {
                data.user_one_id = user_one_id;
            }
            if (user_two_id) {
                data.user_two_id = user_two_id;
            }
        } else {
            data.round = round;
            data.pair = pair;
            if (user_one_id) {
                data.user_one_id = user_one_id;
            }
            if (user_two_id) {
                data.user_two_id = user_two_id;
            }
            if (bracket === 'lower') {
                data.lower_bracket = 1;
            }
        }

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: pair_id ? 'put' : 'post',
            url: PLAYOFF_URL + (pair_id ? '/' + pair_id : ''),
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            processData: false,
            success: response => {
                TRNMNT_helpers.showNotification(response.message);
                if (!pair_id) {
                    $card.data('pairid', response.data.id);
                    $card.find('.play-card__link div')
                        .append('<a href="/versus/' + TOURNAMENT_ID + '/' + response.data.id + '" class="btn btn-link"><i class="fa-solid fa-arrow-right"></i></a>');
                }
            },
            error: TRNMNT_helpers.onErrorAjax,
            context: TRNMNT_helpers
        });
    }
});
